/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable react/jsx-no-comment-textnodes */
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
    Chip,
} from "@nextui-org/react";

import { useNavigate } from "react-router-dom";

import axios from "axios";

const AdminQuoteDetails = () => {
    const { id } = useParams();
    const [quote, setQuote] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const statusColorMap = {
        "awaiting approval": "warning",
        // "awaiting approve": "warning",
        inprogress: "warning",
        accepted: "success",
        dispute: "danger",
        rejected: "danger",
        discarded: "danger",
        cancelled: "danger",
        ordercreated: "secondary",
    };

    useEffect(() => {
        const fetchQuoteDetails = async () => {
            setLoading(true);
            try {
                let token = localStorage.getItem("accessToken");

                let headers = {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Bearer ${token}`,
                    },
                };

                const res = await axios.get(
                    `${process.env.REACT_APP_SERVER_URL}/admin/getquotes/${id}`,
                    headers
                );

                // console.log("Backend Response:", res.data);
                setQuote(res.data?.details);
            } catch (err) {
                console.error("Error fetching quote details:", err.message);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchQuoteDetails();
    }, [id]);



    const status = quote?.Quote?.QuoteStatus?.status?.trim().toLowerCase() || "unknown";
    const chipColor = statusColorMap[status] || "default";



    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error}</p>;

    // console.log("Quote Data:", quote);
    // console.log("Image URL:", quote?.Quote?.quote_images?.[0]?.url);

    return (
        <div className="px-14 select-none">
            <div className="flex justify-between border-b-2 pb-2">
                <h1 className="font-semibold text-lg">Quote Details</h1>
                {/* <Chip className="capitalize " color={chipColor} variant="flat">
                    {quote?.Quote?.QuoteStatus?.status}
                </Chip> */}
                {/* <Chip
                    className={`capitalize border-2 px-3 py-1 ${chipColor === "warning"
                            ? "border-yellow-500 bg-[#FDEDD3] text-[#D59E52]"
                            : chipColor === "success"
                                ? "border-green-500 bg-green-100 text-green-800"
                                : chipColor === "danger"
                                    ? "border-red-500 bg-red-100 text-red-800"
                                    : chipColor === "secondary"
                                        ? "border-gray-500 bg-gray-100 text-gray-800"
                                        : "border-gray-300 bg-gray-200 text-gray-800"
                        }`}
                    variant="flat"
                >
                    {quote?.Quote?.QuoteStatus?.status}
                </Chip> */}

                <div className={`border px-2 py-0.5 flex items-center gap-2 rounded-full 
  ${chipColor === "warning"
                        ? " border-2 border-yellow-500 bg-[#FDEDD3] text-[#D59E52]"
                        : chipColor === "success"
                            ? " border-2 border-green-500 bg-green-100 text-[#26AB83]"
                            : chipColor === "danger"
                                ? " border-2 border-red-500 bg-[#FDD0DF] text-[#EF4B4F]"
                                : chipColor === "secondary"
                                ? "border-gray-300 bg-gray-200 text-black"
                                   : "border-gray-400 bg-[#EEEEEF] text-black"
                    }`}>

                    <div className={`w-2 h-2 rounded-full 
    ${chipColor === "warning"
                            ? "bg-yellow-500"
                            : chipColor === "success"
                                ? "bg-green-500"
                                : chipColor === "danger"
                                    ? "bg-red-500"
                                    : chipColor === "secondary"
                                    ? "bg-gray-300"
                                        : "bg-[#A1A1AA]"
                        }`}
                    ></div>

                    <div className="capitalize text-[14px] leading-[20px] font-[400] font-['Open_Sans',sans-serif]">
                        {quote?.Quote?.QuoteStatus?.status}
                    </div>
                </div>




            </div>

            <div className=" grid grid-cols-1 sm:grid-cols-2 gap-4 text-center">
                <div className="flex justify-center items-center w-full ">
                    {quote?.quote_images?.length > 0 && quote.quote_images[0]?.url ? (
                        <img
                            src={quote.quote_images[0].url}
                            alt="Quote Image"
                            className="w-[400px] h-[400px] object-cover rounded-lg shadow-md"
                        />
                    ) : <h1 className=" opacity-50">No Image Found</h1>}
                </div>



                <div className=" p-6 rounded-lg ">
                    <h1 className="font-bold text-left">Update Quote</h1>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 text-left  py-12">
                        <div>
                            <div className="font-semibold">SalesRep:</div>
                            <div>{quote?.Quote?.SupplierSalesRep?.SalesRepName}</div>
                        </div>
                        <div>
                            <div className="font-semibold">Shipping Date</div>
                            <div>
                                {quote?.Quote?.shipping_date
                                    ? new Date(quote?.Quote?.shipping_date).toLocaleDateString("en-GB", {
                                        day: "2-digit",
                                        month: "long",
                                        year: "numeric",
                                    })
                                    : "No shipping date available"}
                            </div>
                        </div>
                        <div>
                            <div className="font-semibold">WarrantyDuration</div>
                            <div>
                                {quote?.Quote?.warrantyDuration?.unit === "days"
                                    ? `${quote?.Quote?.warrantyDuration?.duration} days`
                                    : quote?.Quote?.warrantyDuration?.unit === "years"
                                        ? `${quote?.Quote?.warrantyDuration?.duration} year(s)`
                                        : "No Available"}
                            </div>
                        </div>

                        <div>
                            <div className="font-semibold">Price AU$</div>
                            <div>{quote?.Quote?.part_price}</div>
                        </div>
                        <div>
                            <div className="font-semibold">Freight Price</div>
                            <div>{quote?.Quote?.freight_price}</div>
                        </div>
                        <div>
                            <div className="font-semibold capitalize">Warranty Option</div>
                            <div>{quote?.Quote?.warranty_option}</div>
                        </div>


                        <div>
                            <div className="font-semibold ">Warranty Price</div>
                            <div>{quote?.Quote?.warranty_price}</div>
                        </div>
                        <div>
                            <div className="font-semibold">Interchange No.</div>
                            <div>{quote?.Quote?.interchange_number}</div>
                        </div>
                        <div>
                            <div className="font-semibold ">Note:</div>
                            <div>{quote?.Quote?.notes}</div>
                        </div>
                    </div>
                </div>

            </div>
            <div className="text-center mt-5">
                {quote?.Quote?.QuoteOptions?.length > 0 ? (
                    <table className="min-w-full border-collapse border border-black">
                        <thead className="text-white">
                            <tr>
                                <th className="border-2 border-black w-[300px] md:w-[180px] py-2 bg-black">Part Type</th>
                                <th className="border-2 border-black w-[300px] md:w-[180px] py-2 bg-black">Custom Part Type</th>
                                <th className="border-2 border-black w-[300px] md:w-[180px] py-2 bg-black">Quantity</th>
                                <th className="border-2 border-black w-[300px] md:w-[180px] py-2 bg-black">Price AU$</th>
                                <th className="border-2 border-black w-[300px] md:w-[180px] py-2 bg-black">Freight Price</th>
                                <th className="border-2 border-black w-[300px] md:w-[180px] py-2 bg-black">Warranty Option</th>
                                <th className="border-2 border-black w-[300px] md:w-[180px] py-2 bg-black">Warranty Price</th>
                                <th className="border-2 border-black w-[300px] md:w-[180px] py-2 bg-black">Notes</th>
                            </tr>
                        </thead>
                        <tbody>
                            {quote?.Quote?.QuoteOptions?.map((option, index) => (
                                <tr key={index} className="border border-black">
                                    <td className="py-2 px-4 border border-black capitalize">{option?.Part?.name.toLowerCase() || "Not Provided"}</td>
                                    <td className="py-2 px-4 border border-black">{option?.Part?.custom_part_type || "Not Provided"}</td>
                                    <td className="py-2 px-4 border border-black">{option?.quantity || "Not Provided"}</td>
                                    <td className="py-2 px-4 border border-black">{option?.part_price || "Not Provided"}</td>
                                    <td className="py-2 px-4 border border-black">{option?.freight_price || "Not Provided"}</td>
                                    <td className="py-2 px-4 border border-black capitalize">{option?.warranty_option?.toLowerCase() || "Not Provided"}</td>
                                    <td className="py-2 px-4 border border-black">{option?.warranty_price || "Not Provided"}</td>
                                    <td className="py-2 px-4 border border-black capitalize">{option?.notes?.toLowerCase() || "Not Provided"}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (
                    ""
                )}
            </div>




        </div>
    );
};

export default AdminQuoteDetails;

/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable react/jsx-no-comment-textnodes */
// import { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import {
//     Chip,
// } from "@nextui-org/react";
// import axios from "axios";

// const AdminQuoteDetails = () => {
//     const { id } = useParams();
//     const [quote, setQuote] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const statusColorMap = {
//         "awaiting approval": "warning",
//         // "awaiting approve": "warning",
//         inprogress: "warning",
//         accepted: "success",
//         dispute: "danger",
//         rejected: "danger",
//         discarded: "danger",
//         cancelled: "danger",
//         ordercreated: "secondary",
//     };

//     useEffect(() => {
//         const fetchQuoteDetails = async () => {
//             setLoading(true);
//             try {
//                 let token = localStorage.getItem("accessToken");

//                 let headers = {
//                     headers: {
//                         "Content-Type": "multipart/form-data",
//                         Authorization: `Bearer ${token}`,
//                     },
//                 };

//                 const res = await axios.get(
//                     `${process.env.REACT_APP_SERVER_URL}/admin/getquotes/${id}`,
//                     headers
//                 );

//                 console.log("Backend Response:", res.data);
//                 setQuote(res.data?.details);
//             } catch (err) {
//                 console.error("Error fetching quote details:", err.message);
//                 setError(err.message);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchQuoteDetails();
//     }, [id]);



//     const status = quote?.Quote?.QuoteStatus?.status?.trim().toLowerCase() || "unknown";
//     const chipColor = statusColorMap[status] || "default";



//     if (loading) return <p>Loading...</p>;
//     if (error) return <p>Error: {error}</p>;

//     console.log("Quote Data:", quote);
//     console.log("Image URL:", quote?.Quote?.quote_images?.[0]?.url);

//     return (
//         <div className="px-14 select-none">
//             <div className="flex justify-between border-b-2 pb-2">
//                 <h1 className="font-semibold text-lg">Quote Details</h1>
//                 <Chip
//                     className={`capitalize border border-${chipColor} text-${chipColor} text-opacity-80 bg-${chipColor}/20`}
//                     color={chipColor}
//                     variant="dot"
//                 >
//                     {quote?.Quote?.QuoteStatus?.status}
//                 </Chip>

//                 {/* <Chip
//                     className={`capitalize border border-${chipColor} text-${chipColor} bg-${chipColor}/20 `}
//                     color={chipColor}
//                     variant="dot"
//                 >
//                     {quote?.Quote?.QuoteStatus?.status}
//                 </Chip> */}


//                 {/* <div className={`border px-2 py-0.5 flex items-center gap-2 rounded-full 
//   ${chipColor === "warning"
//                         ? " border-2 border-yellow-500 bg-[#FDEDD3] text-[#D59E52]"
//                         : chipColor === "success"
//                             ? " border-2 border-green-500 bg-green-100 text-[#26AB83]"
//                             : chipColor === "danger"
//                                 ? " border-2 border-red-500 bg-[#FDD0DF] text-[#EF4B4F]"
//                                 : chipColor === "secondary"
//                                 ? "border-gray-300 bg-gray-200 text-black"
//                                    : "border-gray-400 bg-[#EEEEEF] text-black"
//                     }`}>

//                     <div className={`w-2 h-2 rounded-full 
//     ${chipColor === "warning"
//                             ? "bg-yellow-500"
//                             : chipColor === "success"
//                                 ? "bg-green-500"
//                                 : chipColor === "danger"
//                                     ? "bg-red-500"
//                                     : chipColor === "secondary"
//                                     ? "bg-gray-300"
//                                         : "bg-[#A1A1AA]"
//                         }`}
//                     ></div>

//                     <div className="capitalize text-[14px] leading-[20px] font-[400] font-['Open_Sans',sans-serif]">
//                         {quote?.Quote?.QuoteStatus?.status}
//                     </div>
//                 </div> */}

//             </div>
//             <div className=" grid grid-cols-1 sm:grid-cols-2 gap-4 text-center">
//                 <div className="flex justify-center items-center w-full ">
//                     {quote?.quote_images?.length > 0 && quote.quote_images[0]?.url ? (
//                         <img
//                             src={quote.quote_images[0].url}
//                             alt="Quote Image"
//                             className="w-[400px] h-[400px] object-cover rounded-lg shadow-md"
//                         />
//                     ) : <h1 className=" opacity-50">No Image Found</h1>}
//                 </div>



//                 <div className=" p-6 rounded-lg ">
//                     <h1 className="font-bold text-left">Update Quote</h1>
//                     <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 text-left  py-12">
//                         <div>
//                             <div className="font-semibold">SalesRep:</div>
//                             <div>{quote?.Quote?.SupplierSalesRep?.SalesRepName}</div>
//                         </div>
//                         <div>
//                             <div className="font-semibold">Shipping Date</div>
//                             <div>
//                                 {quote?.Quote?.shipping_date
//                                     ? new Date(quote?.Quote?.shipping_date).toLocaleDateString("en-GB", {
//                                         day: "2-digit",
//                                         month: "long",
//                                         year: "numeric",
//                                     })
//                                     : "No shipping date available"}
//                             </div>
//                         </div>
//                         <div>
//                             <div className="font-semibold">WarrantyDuration</div>
//                             <div>
//                                 {quote?.Quote?.warrantyDuration?.unit === "days"
//                                     ? `${quote?.Quote?.warrantyDuration?.duration} days`
//                                     : quote?.Quote?.warrantyDuration?.unit === "years"
//                                         ? `${quote?.Quote?.warrantyDuration?.duration} year(s)`
//                                         : "No Available"}
//                             </div>
//                         </div>

//                         <div>
//                             <div className="font-semibold">Price AU$</div>
//                             <div>{quote?.Quote?.part_price}</div>
//                         </div>
//                         <div>
//                             <div className="font-semibold">Freight Price</div>
//                             <div>{quote?.Quote?.freight_price}</div>
//                         </div>
//                         <div>
//                             <div className="font-semibold capitalize">Warranty Option</div>
//                             <div>{quote?.Quote?.warranty_option}</div>
//                         </div>


//                         <div>
//                             <div className="font-semibold ">Warranty Price</div>
//                             <div>{quote?.Quote?.warranty_price}</div>
//                         </div>
//                         <div>
//                             <div className="font-semibold">Interchange No.</div>
//                             <div>{quote?.Quote?.interchange_number}</div>
//                         </div>
//                         <div>
//                             <div className="font-semibold ">Note:</div>
//                             <div>{quote?.Quote?.notes}</div>
//                         </div>
//                     </div>
//                 </div>

//             </div>
//             <div className="text-center mt-5">
//                 {quote?.Quote?.QuoteOptions?.length > 0 ? (
//                     <table className="min-w-full border-collapse border border-black">
//                         <thead className="text-white">
//                             <tr>
//                                 <th className="border-2 border-black w-[300px] md:w-[180px] py-2 bg-black">Part Type</th>
//                                 <th className="border-2 border-black w-[300px] md:w-[180px] py-2 bg-black">Custom Part Type</th>
//                                 <th className="border-2 border-black w-[300px] md:w-[180px] py-2 bg-black">Quantity</th>
//                                 <th className="border-2 border-black w-[300px] md:w-[180px] py-2 bg-black">Price AU$</th>
//                                 <th className="border-2 border-black w-[300px] md:w-[180px] py-2 bg-black">Freight Price</th>
//                                 <th className="border-2 border-black w-[300px] md:w-[180px] py-2 bg-black">Warranty Option</th>
//                                 <th className="border-2 border-black w-[300px] md:w-[180px] py-2 bg-black">Warranty Price</th>
//                                 <th className="border-2 border-black w-[300px] md:w-[180px] py-2 bg-black">Notes</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {quote?.Quote?.QuoteOptions?.map((option, index) => (
//                                 <tr key={index} className="border border-black">
//                                     <td className="py-2 px-4 border border-black capitalize">{option?.Part?.name.toLowerCase() || "Not Provided"}</td>
//                                     <td className="py-2 px-4 border border-black">{option?.Part?.custom_part_type || "Not Provided"}</td>
//                                     <td className="py-2 px-4 border border-black">{option?.quantity || "Not Provided"}</td>
//                                     <td className="py-2 px-4 border border-black">{option?.part_price || "Not Provided"}</td>
//                                     <td className="py-2 px-4 border border-black">{option?.freight_price || "Not Provided"}</td>
//                                     <td className="py-2 px-4 border border-black capitalize">{option?.warranty_option?.toLowerCase() || "Not Provided"}</td>
//                                     <td className="py-2 px-4 border border-black">{option?.warranty_price || "Not Provided"}</td>
//                                     <td className="py-2 px-4 border border-black capitalize">{option?.notes?.toLowerCase() || "Not Provided"}</td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 ) : (
//                     ""
//                 )}
//             </div>




//         </div>
//     );
// };

// export default AdminQuoteDetails;
